import { defaultFilters, SORTABLE_FIELDS } from './configurates';

type FilterState = typeof defaultFilters;

export const buildEdgesListParams = (filter: FilterState): string => {
  const params = new URLSearchParams();

  params.set('page', String(filter.currentPage));
  params.set('page_size', String(filter.itemsPerPage));

  if (filter.search) {
    params.set('search', filter.search);
  }

  if (filter.fieldName) {
    const sortBy = SORTABLE_FIELDS[filter.fieldName] ?? 'edge_id';
    params.set('sort_by', sortBy);
    params.set('sort_order', filter.direction === 1 ? 'asc' : 'desc');
  }

  const stringFilters: (keyof FilterState)[] = [
    'data_residency',
    'region_name',
    'region_provider',
    'machine_type',
    'machine_size',
    'edge_version',
    'status'
  ];

  stringFilters.forEach(key => {
    const value = filter[key];
    if (typeof value === 'string' && value) {
      params.set(key, value);
    }
  });

  return params.toString();
};

export const formatUptime = (seconds: number, naLabel = 'N/A'): string => {
  if (seconds == null || seconds < 0) return naLabel;

  const days = Math.floor(seconds / 86400);
  const hours = Math.floor((seconds % 86400) / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  const parts: string[] = [];
  if (days > 0) parts.push(`${days}d`);
  if (hours > 0) parts.push(`${hours}h`);
  if (minutes > 0 || parts.length === 0) parts.push(`${minutes}m`);

  return parts.join(' ');
};

export const formatDate = (dateString: string, naLabel = 'N/A'): string => {
  if (!dateString) return naLabel;
  try {
    return new Date(dateString).toLocaleString();
  } catch {
    return dateString;
  }
};

export const buildUrl = (base: string, params: string): string => {
  return params ? `${base}?${params}` : base;
};
